module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-sda.jpg?v=e47bd1a1";